import {
  TextToPayBeginPaymentResponse,
  TextToPayCompletePaymentRequest,
  TextToPayCompletePaymentResponse,
  TextToPayVisitView,
} from '@m/types/api';
import { apiFetchV2 } from '@m/utils/http';

export const PaymentService = {
  getVisitDetails: ({
    visitCode,
    useSiteRowView = false,
  }: {
    useSiteRowView?: boolean;
    visitCode: string;
  }) =>
    apiFetchV2<TextToPayVisitView>(`/customer/text-to-pay/details/${visitCode}`, {
      params: {
        useSiteRowView,
      },
    }),

  completePayment: ({
    visitCode,
    ...body
  }: TextToPayCompletePaymentRequest & {
    visitCode: string;
  }) =>
    apiFetchV2<TextToPayCompletePaymentResponse>(`/customer/text-to-pay/complete/${visitCode}`, {
      method: 'POST',
      body,
    }),

  /**
   * Tells the backend the consumer is about to confirm the PaymentIntent. Finalizes the bill and
   * verifies the PaymentIntent covers it. Not used on the legacy token path, where `completePayment`
   * is already the commit moment.
   */
  beginPayment: ({ visitCode }: { visitCode: string }) =>
    apiFetchV2<TextToPayBeginPaymentResponse>(`/customer/text-to-pay/begin-payment/${visitCode}`, {
      method: 'POST',
    }),

  wrongVehicle: ({ visitCode }: { visitCode: string }) =>
    apiFetchV2<void>(`/customer/text-to-pay/wrong-vehicle/${visitCode}`, { method: 'PUT' }),
};
